module.exports = __webpack_public_path__ + "img/4.25ae1a31.png";